export const reports6kTests = {
    namespaced: true,

    state: {
        filter: {
            athletes: [],
            gender: '',
            site: '',
            ergo: '',
            date_of_birth: '',
            first_name: '',
            last_name: '',
            sweep_scull: '',
            weight_class: '',
            weight: null,
            height: null,
            tags: [],
            focuses: []
        }
    },

    getters: {
        k6TestFilter(state) {
            return state.filter;
        }
    },

    mutations: {
        resetFilter(state) {
            state.filter = {
                athletes: [],
                gender: '',
                site: '',
                ergo: '',
                date_of_birth: '',
                first_name: '',
                last_name: '',
                sweep_scull: '',
                weight_class: '',
                weight: null,
                height: null,
                tags: [],
                focuses: []
            };
        },

        setFilter(state, filter) {
            state.filter = filter;
        },

        setAthletes(state, athletes) {
            state.filter.athletes = athletes;
        },

        setTags(state, tags) {
            state.filter.tags = tags;
        },

        setFocuses(state, focuses) {
            state.filter.focuses = focuses;
        }
    }
};

export default reports6kTests;
